<script>
import Loading from '../../components/loading.vue';

export default {
    name: "refund",
    data() {
        return {
            list: [
                {
                    image: '',
                    time: '2025-06-26',
                    order_code: '1234567899874562',
                    name: '金满勇限量联名手机壳',
                    count: 1,
                    price: '45.00',
                    isShowLogistics: false,
                    type: 1,
                },
                {
                    image: '',
                    time: '2025-06-26',
                    order_code: '1234567899874562',
                    name: '金满勇限量联名手机壳',
                    count: 1,
                    price: '45.00',
                    isShowLogistics: false,
                    type: 2,
                },
                {
                    image: '',
                    time: '2025-06-26',
                    order_code: '1234567899874562',
                    name: '金满勇限量联名手机壳',
                    count: 1,
                    price: '45.00',
                    isShowLogistics: false,
                    type: 3,
                },
                {
                    image: '',
                    time: '2025-06-26',
                    order_code: '1234567899874562',
                    name: '金满勇限量联名手机壳',
                    count: 1,
                    price: '45.00',
                    isShowLogistics: false,
                    type: 4,
                },
            ],
            isLoading: false,
            isShowPopup: false,
        };
    },
    computed: {},
    components: {
        Loading
    },
    mounted() {},
    destroyed() {},
    watch: {
        isShowPopup: {
            handler: 'popupHandler',
            immediate: true
        },
    },
    methods: {
        // 弹窗显示/隐藏监听
        popupHandler(val) { 
            if(val){
                document.body.style.overflow = 'hidden';
            }else{
                document.body.style.overflow = 'auto';
            }
        },
    },
};
</script>

<template>
    <div class="refund">
        <p class="title">退款管理</p>
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <p class="no_more" v-else-if="list.length == 0">你还没有退款订单</p>
        <div class="order_list">
            <div class="item thead">
                <div class="tr">
                    <div class="td">订单信息</div>
                    <div class="td">退款金额</div>
                    <div class="td">申请时间</div>
                    <div class="td">服务类型</div>
                    <div class="td">退款状态</div>
                    <div class="td">退款操作</div>
                </div>
            </div>
            <div class="item" v-for="(item, index) in list" :key="index">
                <div class="top flex align_center">
                    <p class="time">{{ item.time }}</p>
                    <p class="code">订单号：{{ item.order_code }}</p>
                </div>
                <div class="tr">
                    <div class="td">
                        <div class="info">
                            <router-link class="cover" :style="`background-image: url(${item.image});`" :to="`/shop/detail?id=${item.id}`"></router-link>
                            <div class="wrapper">
                                <p class="name">
                                    <router-link :to="`/shop/detail?id=${item.id}`">{{item.name}}</router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="td price layout_flex_center">RMB {{item.price}}</div>
                    <div class="td gray layout_flex_center">{{ item.time }}</div>
                    <div class="td red layout_flex_center">退货退款</div>
                    <div class="td red layout_flex_center">
                        <p class="red"  v-if="item.type == 1">申请中</p>
                        <p class="green"  v-if="item.type == 2">申请通过</p>
                        <p class="green" v-if="item.type == 3">退款成功</p>
                        <p class="red" v-if="item.type == 4">申请过期</p>
                    </div>
                    <div class="td layout_flex_center">
                        <div class="btn_group">
                            <div class="btn layout_flex_center" v-if="item.type == 2" @click="isShowPopup = true">填写物流信息</div>
                            <div class="btn layout_flex_center" v-if="item.type == 1 || item.type == 2">撤销申请</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup" v-if="isShowPopup">
            <!-- <div class="close position_100" @click="isShowPopup = false"></div> -->
            <div class="in">
                <p class="title">退货并填写物流信息</p>
                <div class="more_info">
                    <p>收货人：奢颜艺术&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;13701998955</p>
                    <p>收货地址：中国江苏省苏州市昆山市花桥镇晨风路6号3号楼607室</p>
                </div>
                <div class="form">
                    <div class="item">
                        <p class="name">物流单号 *</p>
                        <input type="text" placeholder="必填" v-model="code"/>
                    </div>
                    <div class="item">
                        <p class="name">物流公司 *</p>
                        <input type="text" placeholder="必填" v-model="name"/>
                    </div>
                    <div class="item justify_end">
                        <div class="btn" @click="isShowPopup = false">取消</div>
                        <div class="btn">提交</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.refund{
    .popup{
        .in{
            padding: .3rem;
        }
        .more_info{
            font-size: .14rem;
            line-height: 1.5;
            margin-bottom: .3rem;
        }
    }
    .order_list{
        .tr{
            .td{
                flex: 1;
                &:nth-of-type(1){
                    flex: none;
                    width: 38%;
                }
                &:nth-of-type(6){
                    flex: 2;
                }
            }
        }
        .gray{
            color: #999;
        }
        .red{
            color: #ff0000;
        }
        .green{
            color: #13bf34;
        }
    }
}
</style>